import { render, staticRenderFns } from "./CapitalSelector.vue?vue&type=template&id=0d13d999&"
import script from "./CapitalSelector.vue?vue&type=script&lang=js&"
export * from "./CapitalSelector.vue?vue&type=script&lang=js&"
import style0 from "./CapitalSelector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports